import React, { useEffect, useState } from 'react'
import MyListBlock from '../../../../UI/list/MyListBlock'
import Status from '../../../../UI/status/Status'
import { getDateAndTimeText } from '../../../../../helpers/date/dateHelper'
import ChangeStatusOrderButton from '../../forms/changeStatus/ChangeStatusOrderButton'

const SupplyOrderAbout = ({ supplyOrder }) => {

    const [list, setList] = useState([])

    useEffect(() => {
        setListItems()
    }, [supplyOrder])

    const setListItems = () => {
        const listTemp = []

        listTemp.push({
            name: 'Номер',
            value: supplyOrder ? supplyOrder.id : '-'
        })
        listTemp.push({
            name: 'Статус',
            // value: supplyOrder && supplyOrder.status ? supplyOrder.status : '-'
            // value: <Status status={supplyOrder.status} />
            value: 
                <ChangeStatusOrderButton 
                    // status={supplyOrder.status} 
                    supplyOrder={supplyOrder} 
                />
        })
        listTemp.push({
            name: 'Дата створення',
            value: supplyOrder ? getDateAndTimeText(supplyOrder.createdAt) : '-'
        })
        listTemp.push({
            name: 'Опис',
            value: supplyOrder ? supplyOrder.description : '-'
        })
        // listTemp.push({
        //     name: 'Підрозділ',
        //     value: department ? departmentText[department.type] + ' - ' + department.department.name : '-'
        // })
        // listTemp.push({
        //     name: 'Виконавець',
        //     value: user ? getUserName({ user: client }) : '-'
        // })

        setList(listTemp)
    }

  return (
    <MyListBlock 
        className={'supplyOrderView__topBlock'}
        text={'Про заявку'}
        list={list}
    />
    // <div className='supplyOrderView__about'>
    //     about
    // </div>
  )
}

export default SupplyOrderAbout